module.exports = __webpack_public_path__ + "static/newmember1-c2952263c1fbd2d3f9114df377947509.png";